import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";

export class leanPlanningSegmentTableRowCtrl implements IController {
  segment: any;
  index: any;

  public agentSelectionOptions: any;

  constructor() {
  }


  $onInit() {
    this.agentSelectionOptions = [];
  };

  initAgentSelection($mdMenu, event) {
    const assignmentList = _.map(this.segment.assignmentList, (assignment) => {
      return assignment.supplyResourceId;
    });
    this.agentSelectionOptions = _.filter(this.segment.agentList, (agent) => {
      return assignmentList.indexOf(agent.supplyResourceId) === -1
    });
    $mdMenu.open(event)
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('leanPlanningSegmentTableRow', {
    require: {
      TableCtrl: '^leanPlanningSegmentTable'
    },
    bindings: {
      segment: '<',
      index: '<'
    },
    template: require('./lean-planning-segment-table-row.html').default,
    controller: leanPlanningSegmentTableRowCtrl
  });
